import React, { useState, useEffect } from 'react';
import axios from 'axios';

const UploadPDF = () => {
  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState('');
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState('');

  // Fetch courses from the database
  const fetchCourses = async () => {
    try {
      const response = await axios.get('https://schoolofservice.co.za/backend/fetch_courses.php');
      if (response.data.status === 'success') {
        setCourses(response.data.data);
      } else {
        setMessage('Failed to load courses.');
      }
    } catch (error) {
      setMessage('An error occurred while fetching courses.');
    }
  };

  useEffect(() => {
    fetchCourses();
  }, []);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file || !selectedCourse) {
      setMessage('Please select a file and a course.');
      return;
    }

    const formData = new FormData();
    formData.append('pdfFile', file);
    formData.append('courseId', selectedCourse);

    try {
      const response = await axios.post('https://schoolofservice.co.za/backend/upload_pdf.php', formData);
      if (response.data.status === 'success') {
        setMessage('PDF uploaded successfully.');
      } else {
        setMessage(response.data.message || 'Failed to upload PDF.');
      }
    } catch (error) {
      setMessage('An error occurred while uploading the PDF.');
    }
  };

  return (
    <div>
      <h3>Upload PDF</h3>
      {message && <div className="alert alert-info">{message}</div>}
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="pdfFile" className="form-label">Choose PDF File</label>
          <input
            type="file"
            className="form-control"
            id="pdfFile"
            onChange={handleFileChange}
            accept=".pdf"
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="courseSelection" className="form-label">Select Course</label>
          <select
            className="form-select"
            id="courseSelection"
            value={selectedCourse}
            onChange={(e) => setSelectedCourse(e.target.value)}
            required
          >
            <option value="">Select Course</option>
            {courses.map((course) => (
              <option key={course.coursesID} value={course.coursesID}>
                {course.courseName}
              </option>
            ))}
          </select>
        </div>
        <button type="submit" className="btn btn-primary">Upload PDF</button>
      </form>
    </div>
  );
};

export default UploadPDF;
